let debounce: NodeJS.Timer;
export const READ_MORE_INIT_EVENT = "read-more-init";
const initReadMoreAnimation = function () {
    if (debounce) {
        clearTimeout(debounce);
        debounce = undefined;
    }
    debounce = setTimeout(() => {
        document.querySelectorAll(".read-more").forEach((elm: HTMLElement) => {
            elm.classList.add("init", "uninitialized");
            elm.style.removeProperty("--max-height");
            const content = elm.querySelector<HTMLElement>("div.animate-wrap");
            requestAnimationFrame(() => {
                elm.style.setProperty("--max-height", `${content.offsetHeight}px`);
                elm.classList.remove("init");
                requestAnimationFrame(() => elm.classList.remove("uninitialized"));
            });
        });
    }, 100);
};
window.addEventListener("resize", initReadMoreAnimation);
window.addEventListener(READ_MORE_INIT_EVENT, initReadMoreAnimation);
initReadMoreAnimation();
